import React from "react";
import { cn } from "../../utils/cn";
import { ChevronDown } from "lucide-react";

export const Select = React.forwardRef(({
  options = [],
  value,
  onChange,
  optionLabel = "name",
  placeholder = "Selecione uma opção",
  className,
  disabled = false,
  error,
  ...props
}, ref) => {
  const selectedVal = typeof value === "object" && value !== null ? value[optionLabel] || "" : value || "";

  const handleChange = (e) => {
    const rawVal = e.target.value;
    if (!onChange) return;

    // Check if original options were objects
    const found = options.find((opt) => {
      if (typeof opt === "object" && opt !== null) {
        return (opt[optionLabel] || opt.value || opt.label) === rawVal;
      }
      return String(opt) === rawVal;
    });

    onChange({
      target: { value: found !== undefined ? found : rawVal },
      value: found !== undefined ? found : rawVal,
    });
  };

  return (
    <div className="relative w-full">
      <select
        ref={ref}
        disabled={disabled}
        value={selectedVal}
        onChange={handleChange}
        className={cn(
          "w-full appearance-none bg-urb-dark-surface border border-urb-border text-white text-sm rounded-lg px-3.5 py-2.5 pr-10 transition-colors focus:outline-none focus:border-urb-primary focus:ring-1 focus:ring-urb-primary/30 disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer",
          !selectedVal && "text-urb-text-muted",
          error && "border-red-500/80 focus:border-red-500",
          className
        )}
        {...props}
      >
        {placeholder && (
          <option value="" disabled className="bg-urb-card-light text-urb-text-muted">
            {placeholder}
          </option>
        )}
        {options.map((option, idx) => {
          const label = typeof option === "object" && option !== null
            ? option[optionLabel] || option.label || option.name
            : option;
          const val = typeof option === "object" && option !== null
            ? option[optionLabel] || option.value || option.name
            : option;

          return (
            <option key={idx} value={val} className="bg-urb-card-light text-white py-1">
              {label}
            </option>
          );
        })}
      </select>
      <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none text-urb-text-muted">
        <ChevronDown className="w-4 h-4" />
      </div>
      {error && typeof error === "string" && (
        <span className="text-xs text-red-400 mt-1 block">{error}</span>
      )}
    </div>
  );
});

Select.displayName = "Select";
export default Select;
